import { API_BASE } from '../../../lib/config';
import { useState, useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from '../../../authContext/context';
import { postRequest, getRequest } from '../../../lib/api';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';
import Button from '@mui/material/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import UpdateIcon from '@mui/icons-material/Update';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Notes from '../Notes/note';
import './conveyancing-badges.css';
import jsPDF from 'jspdf';
import Swal from 'sweetalert2';

export default function ViewLeadWill() {
  const navigate = useNavigate();
  const { id } = useParams(); // This is lead_id
  const authCtx = useContext(AuthContext);

  const [leadData, setLeadData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [quoteData, setQuoteData] = useState(null);
  const [loadingQuote, setLoadingQuote] = useState(false);
  const [partners, setPartners] = useState([]);
  const [showReviseModal, setShowReviseModal] = useState(false);
  const [revisedNetValue, setRevisedNetValue] = useState(0);
  const [quoteSummaryData, setQuoteSummaryData] = useState(null);
  const [partnerRateCard, setPartnerRateCard] = useState(null);

  // Communication / Email states
  const [emailLogs, setEmailLogs] = useState([]);
  const [loadingEmails, setLoadingEmails] = useState(false);
  const [viewEmailModal, setViewEmailModal] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [contactAttempts, setContactAttempts] = useState(0);

  // Fetch will lead details
  const fetchLeadData = async () => {
    try {
      const response = await postRequest(`private/get-single-lead/${id}`, {}, authCtx.token);
      const lead = response?.data;

      if (lead) {
        console.log('📋 Lead Data Fetched:', lead);
        console.log('📝 About Field:', lead.about);
        console.log('📝 About Type:', Array.isArray(lead.about) ? 'Array' : typeof lead.about);
        console.log('👥 Customers Data:', lead.customers);
        console.log('👤 First Customer:', lead.customers?.[0]);

        // 🎯 Also fetch quote history from final_leads_calculations
        try {
          const calcResponse = await getRequest(`private/getFormattedLeadCalculation/${id}`);
          if (calcResponse?.status === 200 && calcResponse?.data?.quote_history) {
            console.log('📚 Quote History Fetched from final_leads_calculations:', calcResponse.data.quote_history);
            // Merge quote history into lead data
            lead.quote_history = calcResponse.data.quote_history;
          }
        } catch (calcError) {
          console.warn('⚠️ Could not fetch quote history:', calcError);
        }

        setLeadData(lead);
      }
    } catch (error) {
      console.error('Error fetching lead data:', error);
    } finally {
      setLoading(false);
    }
  };

  // 🎯 NEW: Fetch will quote detail from final_leads_calculations
  const fetchWillQuoteDetail = async () => {
    setLoadingQuote(true);
    try {
      console.log('📊 Fetching Will calculation from final_leads_calculations for lead:', id);

      // Use the same API as conveyancing products
      const response = await getRequest(`private/getFormattedLeadCalculation/${id}`);

      console.log('✅ Will Quote Response:', response);

      if (response?.status === 200 && response?.data) {
        console.log('💰 Calculation data:', response.data);

        // Transform data for Will display
        const transformedData = {
          lead_id: response.data.lead_id,
          service_type: response.data.service_type,
          branch_name: response.data.branch_name,
          fees: response.data.fees || [],
          disbursements: response.data.disbursements || [],
          totals: response.data.totals,
          calculated_at: response.data.calculated_at
        };

        setQuoteData(transformedData);
        console.log('✅ Transformed Quote Data Set:', transformedData);
      } else if (response?.status === 404) {
        console.warn('⚠️ No calculation found for this Will lead');
        setQuoteData(null);
      }
    } catch (error) {
      console.error('❌ Error fetching will quote detail:', error);
    } finally {
      setLoadingQuote(false);
    }
  };

  const fetchPartners = async () => {
    try {
      // const res = await postRequest('private/partnersList', {}, authCtx.token);
      // if (res?.status === 200 && res?.data) {
      //   setPartners(res.data);
      // }
    } catch (err) {
      console.error('Error fetching partners:', err);
    }
  };

  // Fetch partner rate card if partner is selected
  const fetchPartnerRateCard = async (partnerId, productId) => {
    if (!partnerId || !productId) {
      setPartnerRateCard(null);
      return;
    }

    try {
      console.log('🔍 Fetching partner rate card for partner:', partnerId, 'product:', productId);
      // const res = await postRequest('private/getPartnerRateCardCost',
      //   { partner_id: partnerId, product_id: productId },
      //   authCtx.token
      // );

      // if (res?.status === 200 && res?.data) {
      //   console.log('✅ Partner Rate Card fetched:', res.data);
      //   setPartnerRateCard(res.data);
      // } else if (res?.status === 407) {
      //   console.log('⚠️ No partner rate card found');
      //   setPartnerRateCard(null);
      // }
    } catch (err) {
      console.error('❌ Error fetching partner rate card:', err);
      setPartnerRateCard(null);
    }
  };

  // Fetch branch rate card if no partner is selected
  const fetchBranchRateCard = async (postcode, productId) => {
    if (!postcode || !productId) {
      setPartnerRateCard(null);
      return;
    }

    try {
      console.log('🏢 Fetching branch rate card for postcode:', postcode, 'product:', productId);

      // First, get branch by postcode
      const branchRes = await postRequest('private/getBranchByPostcode',
        { postcode: postcode },
        authCtx.token
      );

      if (branchRes?.status === 200 && branchRes?.data?.branch_id) {
        const branchId = branchRes.data.branch_id;
        console.log('✅ Branch found:', branchId);

        // Then fetch branch rate card
        const rateCardRes = await postRequest('private/getBranchRateCardCost',
          { branch_id: branchId, product_id: productId },
          authCtx.token
        );

        if (rateCardRes?.status === 200 && rateCardRes?.data) {
          console.log('✅ Branch Rate Card fetched:', rateCardRes.data);
          setPartnerRateCard(rateCardRes.data);
        } else {
          console.log('⚠️ No branch rate card found');
          setPartnerRateCard(null);
        }
      } else {
        console.log('⚠️ No branch found for postcode');
        setPartnerRateCard(null);
      }
    } catch (err) {
      console.error('❌ Error fetching branch rate card:', err);
      setPartnerRateCard(null);
    }
  };

  // Handle Delete Lead
  const handleDeleteLead = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete this Will lead #${id}? This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      try {
        console.log('Attempting to delete lead with ID:', id);

        // Use the DELETE method with fetch API
        const response = await fetch(`/api/v1/admin/private/delete-lead/${id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${authCtx.token}`,
            'Content-Type': 'application/json'
          }
        });

        const data = await response.json();
        console.log('Delete response:', data);

        if (response.ok && (data.status === 200 || data.status === 'success')) {
          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'Will lead has been deleted successfully.'
          }).then(() => {
            navigate('/leads');
          });
        } else {
          throw new Error(data.message || 'Failed to delete lead');
        }
      } catch (error) {
        console.error('Error deleting lead:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Failed to delete lead'
        });
      }
    }
  };

  useEffect(() => {
    if (id && authCtx.token) {
      fetchLeadData();
      // Also fetch quote data for Quote Summary
      fetchQuoteSummaryData();
      fetchPartners();
    }
  }, [id, authCtx.token]);

  // Fetch partner rate card when leadData is available
  useEffect(() => {
    if (leadData?.partner_id && leadData?.product_id) {
      const partnerId = leadData.partner_id?._id || leadData.partner_id;
      const productId = leadData.product_id?._id || leadData.product_id;
      fetchPartnerRateCard(partnerId, productId);
    }
    if (leadData && authCtx.token) {
      fetchEmailLogs();
      fetchEmailTemplates();
      setContactAttempts(leadData.contact_attempts || 0);
    }
  }, [leadData]);

  // 🎯 NEW: Fetch quote data for Quote Summary display from final_leads_calculations
  const fetchQuoteSummaryData = async () => {
    try {
      console.log('📊 Fetching Will Quote Summary Data from final_leads_calculations for lead:', id);
      const response = await getRequest(`private/getFormattedLeadCalculation/${id}`);
      console.log('📊 Quote Summary API Response:', response);

      if (response?.status === 200 && response?.data) {
        // Transform new structure to old format for backward compatibility
        const transformedData = {
          mlmLegalCost: response.data.totals?.total?.net || 0,
          vat: response.data.totals?.total?.vat || 0,
          totalCost: response.data.totals?.total?.gross || 0,
          service_type: response.data.service_type,
          branch_name: response.data.branch_name,
          fees: response.data.fees,
          totals: response.data.totals
        };

        console.log('✅ Quote Summary Data (transformed):', transformedData);
        setQuoteSummaryData(transformedData);
      } else if (response?.status === 404) {
        console.warn('⚠️ No calculation found for this Will lead in final_leads_calculations');
        setQuoteSummaryData(null);
      } else {
        console.error('❌ No data in quote summary response');
      }
    } catch (error) {
      console.error('❌ Error fetching quote summary data:', error);
      console.error('Error details:', error.response || error.message);
    }
  };

  // Fetch email logs/communication history
  const fetchEmailLogs = async () => {
    try {
      setLoadingEmails(true);
      const emailLogsResponse = await postRequest('private/getEmailLogs', {
        lead_id: id,
        page: 1,
        limit: 100
      }, authCtx.token);

      const sentEmails = (emailLogsResponse?.status === 200 || emailLogsResponse?.status === 'success')
        ? (emailLogsResponse.data || [])
        : [];

      setEmailLogs(sentEmails);
      setLoadingEmails(false);
    } catch (error) {
      console.error('Error fetching email logs:', error);
      setEmailLogs([]);
      setLoadingEmails(false);
    }
  };

  // Fetch email templates
  const fetchEmailTemplates = async () => {
    try {
      console.log('📧 === FETCHING WILL AUTOMATION EMAIL TEMPLATES ===');
      console.log('Auth token:', authCtx.token ? 'Present' : 'Missing');
      console.log('Full leadData:', leadData);
      console.log('Lead data product_id:', leadData?.product_id);

      // Get Will product ID from leadData
      let productId = leadData?.product_id?._id || leadData?.product_id;
      console.log('🔍 Product ID from leadData:', productId);

      // If productId is not available, try to fetch it from products API
      if (!productId) {
        console.log('⚠️ Product ID not found in leadData, fetching products...');
        try {
          const productsRes = await postRequest('private/getAllProducts', {}, authCtx.token);
          console.log('📦 Products response:', productsRes);

          if (productsRes?.data) {
            // Find Will product (case-insensitive search)
            const willProduct = productsRes.data.find(p =>
              p.name?.toLowerCase().includes('will') ||
              p.product_name?.toLowerCase().includes('will') ||
              p.title?.toLowerCase().includes('will')
            );

            if (willProduct) {
              productId = willProduct._id || willProduct.product_id;
              console.log('✅ Found Will product:', willProduct);
              console.log('✅ Using product ID:', productId);
            } else {
              console.log('⚠️ Will product not found in products list');
            }
          }
        } catch (prodErr) {
          console.log('❌ Error fetching products:', prodErr);
        }
      }

      // Fetch automation actions for this product
      console.log('📤 Fetching automation actions...');

      const automationUrl = `${API_BASE}/v1/admin/automationList`;
      console.log('🌐 Automation API URL:', automationUrl);

      const requestBody = {
        productId: productId,
        page: 1,
        limit: 100
      };
      console.log('📤 Request body:', JSON.stringify(requestBody, null, 2));

      const response = await fetch(automationUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authCtx.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      const responseData = await response.json();
      console.log('📡 Automations response:', responseData);
      console.log('📡 Response status:', response.status);
      console.log('📡 Response OK:', response.ok);
      console.log('📡 Response data status:', responseData?.status);

      if (response.ok && (responseData?.status === 200 || responseData?.status === 'success')) {
        const automations = responseData.data?.docs || responseData.data || [];
        console.log('✅ Automations found:', automations.length);
        console.log('✅ Full automations array:', JSON.stringify(automations, null, 2));

        // Extract email templates from automation actions
        const emailTemplates = [];

        automations.forEach((automation, index) => {
          console.log(`🔍 [${index}] Checking automation:`, automation.name);
          console.log(`   Full automation data:`, automation);

          // Check if automation has effect with "Send Email"
          if (automation.effect && automation.effect.type?.toLowerCase().includes('send email')) {
            console.log(`   ✅ Found Send Email effect:`, automation.effect.type);

            const template = {
              _id: automation.effect.emailTemplateId?._id || automation._id,
              name: automation.effect.emailTemplateId?.name || 'Unnamed Template',
              template_id: automation.effect.emailTemplateId?._id,
              automation_id: automation._id,
              effect: automation.effect
            };

            emailTemplates.push(template);
            console.log('  ✅ Added email automation to dropdown:', template.name);
          } else {
            console.log(`   ⏭️  Skipping automation (not Send Email type), effect type:`, automation.effect?.type);
          }
        });

        console.log('📧 Total email templates extracted:', emailTemplates.length);
        console.log('📋 Templates list:', emailTemplates);

        setEmailTemplates(emailTemplates);
      } else {
        console.log('⚠️ API returned non-200 status:', responseData);
        setEmailTemplates([]);
      }
    } catch (error) {
      console.error('❌ Error fetching automation email templates:', error);
      setEmailTemplates([]);
    }
  };

  // Handle send email - Updated to match Purchase functionality
  const handleSendEmail = async (templateId, templateName) => {
    try {
      // First show confirmation
      const confirmResult = await Swal.fire({
        icon: 'question',
        title: 'Send Email?',
        html: `<p>Are you sure you want to send <strong>"${templateName}"</strong> to the customer?</p>`,
        showCancelButton: true,
        confirmButtonText: 'Yes, Send Email',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      });

      // If user cancels, return
      if (!confirmResult.isConfirmed) {
        return;
      }

      setSendingEmail(true);

      console.log('📧 Send Email clicked:', {
        templateId,
        templateName,
        lead_id: id
      });

      // Get customer emails
      const customerEmails = leadData?.customers?.map(c => c.email).filter(e => e) || [];

      if (customerEmails.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'No Email Address',
          text: 'No customer email address found for this lead.'
        });
        setSendingEmail(false);
        return;
      }

      const response = await postRequest('private/sendEmailFromTemplate', {
        lead_id: id,
        template_id: templateId,
        customer_emails: customerEmails
      }, authCtx.token);

      if (response?.status === 200 || response?.status === 'success') {
        Swal.fire({
          icon: 'success',
          title: 'Email Sent',
          text: `Email "${templateName}" has been sent successfully!`
        });
        fetchEmailLogs();
      }
    } catch (error) {
      console.error('Error sending email:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to send email'
      });
    } finally {
      setSendingEmail(false);
    }
  };

  // Handle contact attempt update
  const handleUpdateContactAttempt = async (action) => {
    try {
      let newCount = contactAttempts;
      if (action === 'increase') {
        newCount = contactAttempts + 1;
      } else if (action === 'reset') {
        newCount = 0;
      }

      const response = await postRequest('private/updateContactAttempt', {
        lead_id: id,
        contact_attempts: newCount
      }, authCtx.token);

      if (response?.status === 200 || response?.status === 'success') {
        setContactAttempts(newCount);
        Swal.fire({
          icon: 'success',
          title: 'Updated',
          text: `Contact attempts ${action === 'reset' ? 'reset' : 'updated'} successfully!`,
          timer: 1500,
          showConfirmButton: false
        });
      }
    } catch (error) {
      console.error('Error updating contact attempts:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update contact attempts'
      });
    }
  };

  // Handle view email
  const handleViewEmail = (emailLog) => {
    setSelectedEmail(emailLog);
    setViewEmailModal(true);
  };

  // Generate PDF for Will Quote
  const generateWillQuotePDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const margin = 10;
    let yPos = 20;

    const serviceType = leadData?.service_type || quoteData?.service_type || 'Single';
    const leadId = leadData?.lead_id || id;

    // Header
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(`Quote for Will (${serviceType}) #${leadId}`, 10, yPos);
    yPos += 10;

    // Thank you message
    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');
    doc.text(`Thank you for choosing My Law Matters for your Will needs.`, 10, yPos);
    yPos += 15;

    // Total cost summary
    const totalNet = quoteData?.totals?.total?.net || quoteSummaryData?.mlmLegalCost || 0;
    const totalVAT = quoteData?.totals?.total?.vat || quoteSummaryData?.vat || 0;
    const totalGross = quoteData?.totals?.total?.gross || quoteSummaryData?.totalCost || 0;

    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');
    doc.text(`Total Cost: £${totalGross.toFixed(2)}`, 10, yPos);
    doc.setFontSize(9);
    doc.text(`(£${totalNet.toFixed(2)} + £${totalVAT.toFixed(2)} VAT)`, 70, yPos);
    yPos += 10;

    // Table header
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.rect(10, yPos, 90, 6);
    doc.rect(100, yPos, 30, 6);
    doc.rect(130, yPos, 30, 6);
    doc.rect(160, yPos, 30, 6);

    doc.text('Description', 12, yPos + 4);
    doc.text('Net', 110, yPos + 4);
    doc.text('VAT', 140, yPos + 4);
    doc.text('Gross', 168, yPos + 4);
    yPos += 6;

    // Add all fee rows
    if (quoteData?.fees && Object.keys(quoteData.fees).length > 0) {
      // New structure - detailed fees
      Object.entries(quoteData.fees).forEach(([key, fee]) => {
        doc.setFont('helvetica', 'normal');
        doc.rect(10, yPos, 90, 6);
        doc.rect(100, yPos, 30, 6);
        doc.rect(130, yPos, 30, 6);
        doc.rect(160, yPos, 30, 6);

        doc.setFontSize(9);
        const label = fee.label || key;
        const truncatedLabel = label.length > 35 ? label.substring(0, 32) + '...' : label;
        doc.text(truncatedLabel, 12, yPos + 4);

        doc.setFontSize(10);
        doc.text(`£${(fee.amount || 0).toFixed(2)}`, 102, yPos + 4);
        doc.text(`£${(fee.vat || 0).toFixed(2)}`, 132, yPos + 4);
        doc.text(`£${(fee.gross || 0).toFixed(2)}`, 162, yPos + 4);
        yPos += 6;
      });
    } else {
      // Fallback - single legal fees row
      doc.setFont('helvetica', 'normal');
      doc.rect(10, yPos, 90, 6);
      doc.rect(100, yPos, 30, 6);
      doc.rect(130, yPos, 30, 6);
      doc.rect(160, yPos, 30, 6);

      doc.text('Legal Fees', 12, yPos + 4);
      doc.text(`£${totalNet.toFixed(2)}`, 102, yPos + 4);
      doc.text(`£${totalVAT.toFixed(2)}`, 132, yPos + 4);
      doc.text(`£${totalGross.toFixed(2)}`, 162, yPos + 4);
      yPos += 6;
    }

    // Total row
    doc.setFont('helvetica', 'bold');
    doc.rect(10, yPos, 90, 7);
    doc.rect(100, yPos, 30, 7);
    doc.rect(130, yPos, 30, 7);
    doc.rect(160, yPos, 30, 7);

    doc.setFontSize(11);
    doc.text('TOTAL', 12, yPos + 5);
    doc.text(`£${totalNet.toFixed(2)}`, 102, yPos + 5);
    doc.text(`£${totalVAT.toFixed(2)}`, 132, yPos + 5);
    doc.text(`£${totalGross.toFixed(2)}`, 162, yPos + 5);
    yPos += 10;

    // Additional details
    yPos += 5;
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text('This quote is valid for 30 days from the date of issue.', 10, yPos);
    doc.text(`Generated on: ${new Date().toLocaleDateString('en-GB')}`, 10, yPos + 5);

    // Footer
    doc.setFontSize(8);
    doc.text('My Law Matters - Professional Legal Services', 10, doc.internal.pageSize.height - 20);

    // Save the PDF
    const filename = `Will_Quote_${leadId}.pdf`;
    doc.save(filename);

    Swal.fire('Success', 'Quote downloaded successfully!', 'success');
  };

  if (loading) {
    return (
      <>
        <BreadcrumbsWrapper
          items={[
            { label: 'Dashboard', path: '/dashboard' },
            { label: 'Leads', path: '/leads' },
            { label: 'Will Details', path: '' },
          ]}
        />
        <br />
        <div className="text-center py-5">
          <div className="spinner-border text-danger" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 text-muted">Loading will data...</p>
        </div>
      </>
    );
  }

  if (!leadData) {
    return (
      <>
        <BreadcrumbsWrapper
          items={[
            { label: 'Dashboard', path: '/dashboard' },
            { label: 'Leads', path: '/leads' },
            { label: 'Will Details', path: '' },
          ]}
        />
        <br />
        <div className="alert alert-danger text-center">
          <h5>Lead not found</h5>
        </div>
      </>
    );
  }

  // Get customer name
  const customerName = leadData?.customers?.[0]
    ? `${leadData.customers[0].forename || ''} ${leadData.customers[0].surname || ''}`.trim()
    : 'sohn doe';

  const postcode = typeof leadData?.address === 'object'
    ? leadData?.address?.postcode || 'N/A'
    : 'N/A';

  // Helper function to check if about option is selected
  const isAboutSelected = (checkText) => {
    if (!leadData?.about) return false;

    // If about is an array (new format)
    if (Array.isArray(leadData.about)) {
      return leadData.about.includes(checkText);
    }

    // If about is an object (old format)
    const mapping = {
      "Do you wish to leave the whole of your estate to your spouse/civil partner?": leadData.about.leave_whole_estate,
      "Do you own more than one property?": leadData.about.own_more_than_one_property,
      "Do you wish to leave any assets to your grandchildren or minor children?": leadData.about.leave_assets_to_grandchildren,
      "Do you wish to exclude any of your relatives from your Will?": leadData.about.exclude_relatives,
      "Do you have any Foreign Assets?": leadData.about.have_foreign_assets,
      "Will there be more than 5 beneficiaries?": leadData.about.more_than_5_beneficiaries,
      "Would you like to leave the right to usage of your property to someone?": leadData.about.leave_right_to_usage
    };

    return mapping[checkText] || false;
  };

  return (
    <>
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Leads', path: '/leads' },
          { label: `Will (${leadData?.service_type || 'Single'}) #${leadData?.lead_id || id}`, path: '' },
        ]}
      />
      <br />

      <div className='page-header pb-3 mb-3'>
        <div className="d-flex align-items-center justify-content-between">
          <h1 className='mt-0 mb-0' style={{ fontSize: '1.5rem', fontWeight: '500' }}>
            Will ({leadData?.service_type || 'Single'})
            <span style={{ color: '#6c757d', marginLeft: '10px' }}>#{leadData?.lead_id || id}</span>

            {/* Group Code Badge */}
            {leadData?.group_code && (
              <span className="badge" style={{
                backgroundColor: '#bb0000',
                color: 'white',
                padding: '6px 12px',
                fontSize: '0.875rem',
                fontWeight: '500',
                marginLeft: '20px'
              }}>
                {leadData.group_code?.code || leadData.group_code?.name || 'N/A'}
              </span>
            )}

            {/* Status Badge */}
            {leadData?.status && (
              <span className="badge bg-success" style={{
                padding: '6px 12px',
                fontSize: '0.875rem',
                fontWeight: '500',
                marginLeft: '10px'
              }}>
                {leadData.status}
                {leadData.sub_status && ` - ${leadData.sub_status}`}
              </span>
            )}
          </h1>
        </div>
      </div>

      <div className='page-top-formview mb-3'>
        <div className='customer-tab-view leads-tab-view'>
          <Tabs defaultActiveKey="overview" id="will-tabs">
            {/* OVERVIEW TAB */}
            <Tab eventKey="overview" title="Overview">
              <div className='mt-3'>

                {/* Quote Summary Card */}
                <div className="card shadow-sm mb-4" style={{ borderRadius: '10px', overflow: 'hidden' }}>
                  <div className="card-header" style={{
                    backgroundColor: '#f8f9fa',
                    borderBottom: '2px solid #e9ecef',
                    padding: '1rem 1.25rem'
                  }}>
                    <h5 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>
                      Quote Summary
                    </h5>
                  </div>
                  <div className="card-body" style={{ padding: '1.5rem' }}>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex align-items-baseline gap-3">
                          <span className="text-muted small">Total Cost</span>
                          {!quoteSummaryData ? (
                            <span style={{ color: '#6c757d', fontWeight: '400', fontSize: '0.95rem' }}>
                              Loading quote...
                            </span>
                          ) : (
                            <span style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.1rem' }}>
                              £{(quoteSummaryData.totalCost || 0).toFixed(2)} Gross
                              <span style={{ fontWeight: '400' }}>
                                {' '}(£{(quoteSummaryData.mlmLegalCost || 0).toFixed(2)} Net + £{(quoteSummaryData.vat || 0).toFixed(2)} VAT)
                              </span>
                            </span>
                          )}
                        </div>
                        {(quoteSummaryData?.complexity || leadData?.complexity) && (
                          <div className="d-flex align-items-baseline gap-3">
                            <span className="text-muted small">Complexity</span>
                            <span style={{ color: '#495057', fontWeight: '500', fontSize: '0.95rem' }}>
                              {quoteSummaryData?.complexity || leadData?.complexity}
                            </span>
                          </div>
                        )}
                      </div>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          console.log('🔍 View Quote Detail clicked');
                          console.log('📊 Fetching latest calculation from final_leads_calculations...');

                          // 🎯 NEW: Always fetch from final_leads_calculations API
                          fetchWillQuoteDetail();

                          setShowQuoteModal(true);
                        }}
                        style={{
                          color: '#007bff',
                          textDecoration: 'none',
                          fontSize: '0.875rem',
                          fontWeight: '500',
                          cursor: 'pointer'
                        }}
                      >
                        View Quote Detail
                      </a>
                    </div>

                    <hr style={{
                      margin: '1rem 0',
                      borderTop: '1px solid #dee2e6',
                      border: 'none',
                      borderTopWidth: '1px',
                      borderTopStyle: 'solid',
                      borderTopColor: '#dee2e6',
                      opacity: 1
                    }} />

                    <div className="d-flex gap-2 mb-3">
                      <span className="badge" style={{
                        backgroundColor: '#6c757d',
                        color: 'white',
                        padding: '4px 10px',
                        fontSize: '0.75rem',
                        fontWeight: '500'
                      }}>
                        Branch
                      </span>
                      <span className="badge" style={{
                        backgroundColor: '#17a2b8',
                        color: 'white',
                        padding: '4px 10px',
                        fontSize: '0.75rem',
                        fontWeight: '500'
                      }}>
                        Universal
                      </span>
                      <span className="text-muted" style={{ fontSize: '0.875rem', marginLeft: '4px' }}>
                        {new Date(leadData?.createdAt || Date.now()).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })} at {new Date(leadData?.createdAt || Date.now()).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>

                    <hr style={{
                      margin: '0 0 1rem 0',
                      borderTop: '1px solid #dee2e6',
                      border: 'none',
                      borderTopWidth: '1px',
                      borderTopStyle: 'solid',
                      borderTopColor: '#dee2e6',
                      opacity: 1
                    }} />

                    {/* Action Buttons */}
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-sm"
                        style={{
                          backgroundColor: '#dc3545',
                          color: 'white',
                          border: 'none',
                          padding: '6px 16px',
                          fontWeight: '500',
                          fontSize: '0.875rem',
                          borderRadius: '4px'
                        }}
                        onClick={async (e) => {
                          e.preventDefault();
                          // Set initial revised value from quote summary data or quote data
                          setRevisedNetValue(quoteSummaryData?.mlmLegalCost || quoteData?.mlmLegalCost || 0);
                          setShowReviseModal(true);
                        }}
                      >
                        <i className="fas fa-edit me-1"></i> Revise Quote
                      </button>
                      <button
                        className="btn btn-sm"
                        style={{
                          backgroundColor: 'white',
                          color: '#6c757d',
                          border: '1px solid #ced4da',
                          padding: '6px 16px',
                          fontWeight: '500',
                          fontSize: '0.875rem',
                          borderRadius: '4px'
                        }}
                        onClick={async (e) => {
                          e.preventDefault();

                          // Show confirmation dialog
                          const confirmResult = await Swal.fire({
                            title: 'Regenerate Original Quote?',
                            text: 'This will restore the original quote values. Current changes will be saved to history.',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, regenerate it!'
                          });

                          if (!confirmResult.isConfirmed) {
                            return;
                          }

                          try {
                            console.log('🔄 Regenerating Will quote for ID:', id);
                            console.log('📋 Lead Data:', leadData);
                            console.log('🏢 Branch ID:', leadData?.branch_id);
                            console.log('📦 Product ID:', leadData?.product_id);

                            // Call API to regenerate quote (recalculate from Will branch settings)
                            const response = await postRequest(
                              `private/regenerate-will-quote/${id}`,
                              {},
                              authCtx.token
                            );

                            console.log('✅ Regenerate API Response:', response);

                            if (response?.status === 200) {
                              // Refresh lead data to get updated values
                              await fetchLeadData();

                              // Show success message and reload
                              Swal.fire('Success', 'Original quote restored successfully!', 'success').then(() => {
                                window.location.reload();
                              });
                            } else {
                              Swal.fire('Error', response?.message || 'Failed to regenerate quote', 'error');
                            }
                          } catch (error) {
                            console.error('❌ Error regenerating quote:', error);
                            console.error('Error details:', error.response || error.message);

                            // Check if it's a missing product ID error
                            const errorMessage = error.response?.data?.message || error.message;
                            if (errorMessage?.includes('Product ID')) {
                              Swal.fire('Error', 'Lead is missing Product ID. Please ensure the lead has this field populated.', 'error');
                            } else {
                              Swal.fire('Error', errorMessage || 'Failed to regenerate quote', 'error');
                            }
                          }
                        }}
                      >
                        <i className="fas fa-redo me-1"></i> Regenerate Quote
                      </button>
                    </div>
                  </div>
                </div>

                {/* Details Table */}
                <div className="card shadow-sm" style={{ borderRadius: '8px' }}>
                  <div className="card-body p-0">
                    <table className="table table-borderless mb-0" style={{ fontSize: '0.9rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td style={{ padding: '12px 16px', fontWeight: '500', color: '#495057', width: '35%' }}>
                            Customer
                          </td>
                          <td style={{ padding: '12px 16px', color: '#212529' }}>
                            {customerName}
                          </td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td style={{ padding: '12px 16px', fontWeight: '500', color: '#495057' }}>
                            Postcode
                          </td>
                          <td style={{ padding: '12px 16px', color: '#212529' }}>
                            {postcode}
                          </td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td style={{ padding: '12px 16px', fontWeight: '500', color: '#495057' }}>
                            Type of Service
                          </td>
                          <td style={{ padding: '12px 16px', color: '#212529' }}>
                            {leadData?.service_type || 'Single'}
                          </td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td style={{ padding: '12px 16px', fontWeight: '500', color: '#495057' }}>
                            Complexity
                          </td>
                          <td style={{ padding: '12px 16px', color: '#212529' }}>
                            {quoteSummaryData?.complexity || leadData?.complexity || '-'}
                          </td>
                        </tr>

                        {/* Lender Panel */}
                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td style={{ padding: '12px 16px', fontWeight: '500', color: '#495057' }}>
                            Lender Panel
                          </td>
                          <td style={{ padding: '12px 16px', color: '#212529' }}>
                            {leadData?.lender_panel_id?.name ? (
                              <div>
                                <div style={{ color: '#495057' }}>
                                  {leadData.lender_panel_id.name}
                                </div>
                                {leadData?.lender_panel_id?.lender_numbers && leadData.lender_panel_id.lender_numbers.length > 0 && (
                                  <div style={{ color: '#6c757d', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                                        <span style={{ fontWeight: '500' }}>Lender Panel Number: </span>
                                    {leadData.lender_panel_id.lender_numbers.join(', ')}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <span className="text-muted">Not specified</span>
                            )}
                          </td>
                        </tr>

                        {/* Partner */}
                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td style={{ padding: '12px 16px', fontWeight: '500', color: '#495057' }}>
                            Partner
                          </td>
                          <td style={{ padding: '12px 16px', color: '#212529' }}>
                            {(() => {
                              if (leadData?.partner_id) {
                                const partnerId = typeof leadData.partner_id === 'object' ? leadData.partner_id._id : leadData.partner_id;
                                const partner = partners.find(p => p._id === partnerId);
                                if (partner) {
                                  return partner.companyname || partner.name;
                                }
                                // If populated object but not in partners list
                                if (typeof leadData.partner_id === 'object') {
                                  return leadData.partner_id.companyname || leadData.partner_id.name;
                                }
                              }
                              return <span className="text-muted">Not specified</span>;
                            })()}
                          </td>
                        </tr>

                        {/* About Section - Checkboxes */}
                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td colSpan="2" style={{ padding: '12px 16px' }}>
                            <div className="d-flex align-items-center">
                              {isAboutSelected("Do you wish to leave the whole of your estate to your spouse/civil partner?") ? (
                                <CheckIcon style={{ color: '#28a745', fontSize: '18px', marginRight: '8px' }} />
                              ) : (
                                <CloseIcon style={{ color: '#dc3545', fontSize: '18px', marginRight: '8px' }} />
                              )}
                              <span style={{ color: '#212529', fontSize: '0.9rem' }}>
                                Do you wish to leave the whole of your estate to your spouse/civil partner?
                              </span>
                            </div>
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td colSpan="2" style={{ padding: '12px 16px' }}>
                            <div className="d-flex align-items-center">
                              {isAboutSelected("Do you own more than one property?") ? (
                                <CheckIcon style={{ color: '#28a745', fontSize: '18px', marginRight: '8px' }} />
                              ) : (
                                <CloseIcon style={{ color: '#dc3545', fontSize: '18px', marginRight: '8px' }} />
                              )}
                              <span style={{ color: '#212529', fontSize: '0.9rem' }}>
                                Do you own more than one property?
                              </span>
                            </div>
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td colSpan="2" style={{ padding: '12px 16px' }}>
                            <div className="d-flex align-items-center">
                              {isAboutSelected("Do you wish to leave any assets to your grandchildren or minor children?") ? (
                                <CheckIcon style={{ color: '#28a745', fontSize: '18px', marginRight: '8px' }} />
                              ) : (
                                <CloseIcon style={{ color: '#dc3545', fontSize: '18px', marginRight: '8px' }} />
                              )}
                              <span style={{ color: '#212529', fontSize: '0.9rem' }}>
                                Do you wish to leave any assets to your grandchildren or minor children?
                              </span>
                            </div>
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td colSpan="2" style={{ padding: '12px 16px' }}>
                            <div className="d-flex align-items-center">
                              {isAboutSelected("Do you wish to exclude any of your relatives from your Will?") ? (
                                <CheckIcon style={{ color: '#28a745', fontSize: '18px', marginRight: '8px' }} />
                              ) : (
                                <CloseIcon style={{ color: '#dc3545', fontSize: '18px', marginRight: '8px' }} />
                              )}
                              <span style={{ color: '#212529', fontSize: '0.9rem' }}>
                                Do you wish to exclude any of your relatives from your Will?
                              </span>
                            </div>
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td colSpan="2" style={{ padding: '12px 16px' }}>
                            <div className="d-flex align-items-center">
                              {isAboutSelected("Do you have any Foreign Assets?") ? (
                                <CheckIcon style={{ color: '#28a745', fontSize: '18px', marginRight: '8px' }} />
                              ) : (
                                <CloseIcon style={{ color: '#dc3545', fontSize: '18px', marginRight: '8px' }} />
                              )}
                              <span style={{ color: '#212529', fontSize: '0.9rem' }}>
                                Do you have any Foreign Assets?
                              </span>
                            </div>
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td colSpan="2" style={{ padding: '12px 16px' }}>
                            <div className="d-flex align-items-center">
                              {isAboutSelected("Will there be more than 5 beneficiaries?") ? (
                                <CheckIcon style={{ color: '#28a745', fontSize: '18px', marginRight: '8px' }} />
                              ) : (
                                <CloseIcon style={{ color: '#dc3545', fontSize: '18px', marginRight: '8px' }} />
                              )}
                              <span style={{ color: '#212529', fontSize: '0.9rem' }}>
                                Will there be more than 5 beneficiaries?
                              </span>
                            </div>
                          </td>
                        </tr>

                        <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td colSpan="2" style={{ padding: '12px 16px' }}>
                            <div className="d-flex align-items-center">
                              {isAboutSelected("Would you like to leave the right to usage of your property to someone?") ? (
                                <CheckIcon style={{ color: '#28a745', fontSize: '18px', marginRight: '8px' }} />
                              ) : (
                                <CloseIcon style={{ color: '#dc3545', fontSize: '18px', marginRight: '8px' }} />
                              )}
                              <span style={{ color: '#212529', fontSize: '0.9rem' }}>
                                Would you like to leave the right to usage of your property to someone?
                              </span>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td style={{ padding: '12px 16px', fontWeight: '500', color: '#495057' }}>
                            Approximate Value of Assets
                          </td>
                          <td style={{ padding: '12px 16px', color: '#212529' }}>
                            {leadData?.approximate_value_of_assets || '£500,000 - £1,000,000'}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Footer */}
                  <div className="card-footer bg-white d-flex justify-content-between align-items-center" style={{ borderTop: '1px solid #e9ecef', padding: '12px 16px' }}>
                    <Button
                      variant="outlined"
                      className="text-capitalize"
                      onClick={() => navigate(`/leads/edit/will/${id}`)}
                      style={{
                        color: '#6c757d',
                        borderColor: '#6c757d',
                        fontSize: '0.875rem',
                        padding: '6px 16px',
                        textTransform: 'none'
                      }}
                    >
                      <EditOutlinedIcon fontSize="small" style={{ marginRight: '6px' }} />
                      Edit
                    </Button>

                    <div className="d-flex flex-column align-items-end gap-1">
                      <span className="text-muted" style={{ fontSize: '0.875rem' }}>
                        Created: {new Date(leadData.createdAt || Date.now()).toLocaleDateString('en-GB')} - {leadData?.created_id?.name || 'djethwa'}
                      </span>

                      <Dropdown>
                        <Dropdown.Toggle
                          variant="outlined"
                          size="small"
                          className="text-capitalize"
                          style={{
                            backgroundColor: 'white',
                            color: '#6c757d',
                            border: '1px solid #ced4da',
                            padding: '6px 16px',
                            fontWeight: '500',
                            fontSize: '0.875rem',
                            borderRadius: '4px'
                          }}
                        >
                          More Actions
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              navigate('/leads/changestatus', {
                                state: {
                                  leadId: id,
                                  currentStatus: leadData?.status,
                                  returnUrl: window.location.pathname
                                }
                              });
                            }}
                          >
                            <UpdateIcon fontSize="small" style={{ marginRight: '8px' }} />
                            Change Status
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => {
                              navigate('/leads/changegroupcode', {
                                state: {
                                  leadId: id,
                                  currentGroupCode: leadData?.group_code,
                                  returnUrl: window.location.pathname
                                }
                              });
                            }}
                          >
                            <EditOutlinedIcon fontSize="small" style={{ marginRight: '8px' }} />
                            Change Group Code
                          </Dropdown.Item>

                          <Dropdown.Divider />

                          <Dropdown.Item
                            onClick={handleDeleteLead}
                            style={{ color: '#dc3545' }}
                          >
                            <DeleteOutlineOutlinedIcon fontSize="small" style={{ marginRight: '8px' }} />
                            Delete Lead
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>

              </div>
            </Tab>

            {/* QUOTES TAB */}
            <Tab eventKey="quotes" title="Quotes">
              <div className="mt-3">
                {/* Current Quote Card */}
                {(quoteSummaryData || leadData?.net_amount) && (
                  <div className="card mb-3" style={{ border: '1px solid #dee2e6' }}>
                    <div className="card-body">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <h5 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#2c3e50', margin: 0 }}>
                          £{(quoteSummaryData?.totalCost || leadData?.total_quote || 0).toFixed(2)}
                        </h5>
                        <span className="badge bg-primary" style={{ padding: '8px 15px', fontSize: '0.9rem' }}>
                          {leadData?.branch_name || 'Branch'}
                        </span>
                      </div>
                      <p style={{ color: '#6c757d', fontSize: '0.95rem', marginBottom: 0 }}>
                        <i className="far fa-calendar-alt me-2"></i>
                        {leadData?.quote_date ? new Date(leadData.quote_date).toLocaleString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        }) : new Date(leadData?.updatedAt || Date.now()).toLocaleString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </p>
                      <Button
                        variant="link"
                        className="text-decoration-none p-0 mt-2"
                        onClick={(e) => {
                          e.preventDefault();
                          console.log('🔍 View Quote Detail (Summary) clicked');
                          // 🎯 NEW: Always fetch latest from final_leads_calculations
                          fetchWillQuoteDetail();
                          setShowQuoteModal(true);
                        }}
                      >
                        View Quote Detail
                      </Button>
                    </div>
                  </div>
                )}

                {/* Quote History Section - Enhanced UI */}
                {leadData?.quote_history && leadData.quote_history.length > 0 && (
                  <div className="quote-history-section">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c3e50' }}>
                        <i className="fas fa-history me-2" style={{ color: '#3498db' }}></i>
                        Quote History
                      </h5>
                      <span className="badge bg-primary" style={{ fontSize: '0.9rem', padding: '6px 12px' }}>
                        {leadData.quote_history.length} {leadData.quote_history.length === 1 ? 'Version' : 'Versions'}
                      </span>
                    </div>

                    <div className="timeline" style={{ position: 'relative', paddingLeft: '30px' }}>
                      {/* Timeline line */}
                      <div style={{
                        position: 'absolute',
                        left: '8px',
                        top: '20px',
                        bottom: '20px',
                        width: '2px',
                        backgroundColor: '#e0e0e0'
                      }}></div>

                      {[...leadData.quote_history].reverse().map((quote, index) => {
                        const totalAmount = quote.total_quote || 0;
                        const totalVat = quote.vat_amount || 0;
                        const isActive = quote.is_active || false;
                        const revisionNumber = quote.revision_number || 1;
                        const source = quote.calculation_source || 'api';

                        // Use revision_label directly from API
                        const versionLabel = quote.revision_label || `Revision ${revisionNumber}`;

                        // Format date
                        const displayDate = quote.revised_at || quote.createdAt;

                        // Icon and color based on type
                        let iconClass = 'fa-file-invoice';
                        let iconColor = '#95a5a6';
                        let borderColor = '#e0e0e0';

                        if (isActive) {
                          iconClass = 'fa-check-circle';
                          iconColor = '#27ae60';
                          borderColor = '#27ae60';
                        } else if (versionLabel === 'Original') {
                          iconClass = 'fa-star';
                          iconColor = '#f39c12';
                        } else if (source === 'manual_revision') {
                          iconClass = 'fa-edit';
                          iconColor = '#3498db';
                        }

                        return (
                          <div key={quote._id || index} style={{ position: 'relative', marginBottom: '24px' }}>
                            {/* Timeline dot */}
                            <div style={{
                              position: 'absolute',
                              left: '-26px',
                              top: '16px',
                              width: '16px',
                              height: '16px',
                              borderRadius: '50%',
                              backgroundColor: iconColor,
                              border: '3px solid white',
                              boxShadow: '0 0 0 2px ' + iconColor,
                              zIndex: 1
                            }}></div>

                            {/* Card */}
                            <div className="card" style={{
                              border: `2px solid ${isActive ? borderColor : '#e9ecef'}`,
                              borderRadius: '12px',
                              boxShadow: isActive ? '0 4px 12px rgba(39, 174, 96, 0.15)' : '0 2px 8px rgba(0,0,0,0.08)',
                              transition: 'all 0.3s ease',
                              backgroundColor: isActive ? '#f8fff9' : 'white'
                            }}>
                              <div className="card-body" style={{ padding: '20px' }}>
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                  {/* Left: Version & Amount */}
                                  <div className="flex-grow-1">
                                    <div className="d-flex align-items-center gap-2 mb-2">
                                      <i className={`fas ${iconClass}`} style={{ color: iconColor, fontSize: '18px' }}></i>
                                      <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c3e50' }}>
                                        {versionLabel}
                                      </h5>
                                      {isActive && (
                                        <span className="badge" style={{
                                          backgroundColor: '#27ae60',
                                          color: 'white',
                                          padding: '4px 10px',
                                          borderRadius: '6px',
                                          fontSize: '0.75rem',
                                          fontWeight: 600
                                        }}>
                                          CURRENT
                                        </span>
                                      )}
                                    </div>

                                    {/* Date & Time */}
                                    <p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                                      <i className="far fa-clock me-1"></i>
                                      {new Date(displayDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric'
                                      })} at {new Date(displayDate).toLocaleTimeString('en-GB', {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                      })}
                                    </p>

                                    {/* Source Badge */}
                                    <span className="badge" style={{
                                      backgroundColor: source === 'manual_revision' ? '#3498db' : '#95a5a6',
                                      color: 'white',
                                      padding: '4px 8px',
                                      borderRadius: '4px',
                                      fontSize: '0.7rem'
                                    }}>
                                      {source === 'manual_revision' ? 'MANUAL REVISION' :
                                       source === 'api' ? 'AUTO CALCULATED' :
                                       source.toUpperCase()}
                                    </span>
                                  </div>

                                  {/* Right: Branch & Action */}
                                  <div className="d-flex flex-column align-items-end gap-2">
                                    {quote.branch_name && (
                                      <span className="badge" style={{
                                        backgroundColor: '#e8f4f8',
                                        color: '#3498db',
                                        padding: '6px 12px',
                                        borderRadius: '6px',
                                        fontSize: '0.75rem',
                                        fontWeight: 600
                                      }}>
                                        <i className="fas fa-building me-1"></i>
                                        {quote.branch_name}
                                      </span>
                                    )}
                                    <Button
                                      variant="outline-primary"
                                      size="sm"
                                      style={{
                                        borderRadius: '8px',
                                        padding: '6px 16px',
                                        fontSize: '0.8rem',
                                        fontWeight: 500,
                                        borderWidth: '2px'
                                      }}
                                      onClick={() => {
                                        console.log('🔍 View Quote clicked for:', versionLabel);
                                        setQuoteData({
                                          mlmLegalCost: quote.net_amount,
                                          vat: quote.vat_amount,
                                          totalCost: quote.total_quote,
                                          service_type: leadData?.service_type
                                        });
                                        setShowQuoteModal(true);
                                      }}
                                    >
                                      <VisibilityIcon fontSize="small" style={{ fontSize: '14px', marginRight: '4px' }} />
                                      View Details
                                    </Button>
                                  </div>
                                </div>

                                {/* Pricing Breakdown */}
                                <div className="mt-3 pt-3" style={{ borderTop: '1px solid #e9ecef' }}>
                                  <div className="row g-3">
                                    {/* Total Amount - Highlighted */}
                                    <div className="col-md-6">
                                      <div style={{
                                        backgroundColor: isActive ? '#e8f5e9' : '#f8f9fa',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        textAlign: 'center'
                                      }}>
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase' }}>
                                          Total Amount
                                        </p>
                                        <h4 className="mb-0" style={{ color: isActive ? '#27ae60' : '#2c3e50', fontWeight: 700 }}>
                                          £{Number(totalAmount).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </h4>
                                      </div>
                                    </div>

                                    {/* VAT */}
                                    <div className="col-md-6">
                                      <div style={{ padding: '12px' }}>
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                          <i className="fas fa-receipt me-1"></i>
                                          VAT Included
                                        </p>
                                        <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: 600 }}>
                                          £{Number(totalVat).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* No quotes message */}
                {(!quoteSummaryData && !leadData?.net_amount) && (!leadData?.quote_history || leadData.quote_history.length === 0) && (
                  <div className="text-center py-5">
                    <i className="fas fa-file-invoice fa-3x text-muted mb-3"></i>
                    <h5 className="text-muted">No Quotes Available</h5>
                    <p className="text-muted">No quotes have been generated yet.</p>
                  </div>
                )}
              </div>
            </Tab>

            {/* NOTES TAB */}
            <Tab eventKey="notes" title="Notes">
              <div className='mt-3'>
                <Notes lead_id={id} />
              </div>
            </Tab>

            {/* COMMUNICATION TAB */}
            <Tab eventKey="communication" title="Communication">
              <div className='communication-table'>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Dropdown>
                    <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                      Contact Attempt ({contactAttempts})
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleUpdateContactAttempt('increase')}>
                        <MailOutlineIcon fontSize="small" /> &nbsp; Increase Contact Attempt Count
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleUpdateContactAttempt('reset')}>
                        <CallOutlinedIcon fontSize="small" /> &nbsp; Reset
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <div className="d-flex align-items-center gap-2">
                    <Dropdown>
                      <Dropdown.Toggle variant="primary" id="send-email-dropdown" disabled={sendingEmail}>
                        {sendingEmail ? 'Sending...' : 'Send Email'}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {emailTemplates.length === 0 ? (
                          <Dropdown.Item disabled>No templates available</Dropdown.Item>
                        ) : (
                          emailTemplates.map((template) => (
                            <Dropdown.Item
                              key={template._id}
                              onClick={() => handleSendEmail(template._id, template.name)}
                            >
                              {template.name}
                            </Dropdown.Item>
                          ))
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => {
                        fetchEmailTemplates();
                        fetchEmailLogs();
                      }}
                      title="Refresh templates and logs"
                    >
                      <RefreshIcon fontSize="small" />
                    </Button>
                  </div>
                </div>
                <div className="mt-4">
                  <table className="table table-striped table-responsive table-bordered">
                    <thead>
                      <tr>
                        <th>Sent</th>
                        <th>Customer</th>
                        <th>Content</th>
                        <th style={{ width: '80px', textAlign: 'center' }}>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingEmails ? (
                        <tr>
                          <td colSpan="4" className="text-center">Loading...</td>
                        </tr>
                      ) : emailLogs.length === 0 ? (
                        <tr>
                          <td colSpan="4" className="text-center">No communication logs found</td>
                        </tr>
                      ) : (
                        emailLogs.map((log, index) => (
                          <tr key={log._id || index}>
                            <td>
                              {log.sent_at ? new Date(log.sent_at).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              }) : 'N/A'}
                            </td>
                            <td>
                              <div>
                                {log.recipient_name || log.customer_id?.forename || 'Unknown'}
                                <div className="text-muted small">{log.recipient_email}</div>
                              </div>
                            </td>
                            <td>
                              <div>
                                <strong>{log.template_name || log.subject || 'No title'}</strong>
                                <div className="text-muted small">
                                  {log.subject && log.subject !== log.template_name && (
                                    <span>Subject: {log.subject}</span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => handleViewEmail(log)}
                                title="View email content"
                                sx={{ minWidth: '40px', padding: '4px 8px' }}
                              >
                                <VisibilityIcon fontSize="small" />
                              </Button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Tab>

            {/* TASKS TAB */}
            <Tab eventKey="tasks" title="Tasks">
              <div className='mt-3'>
                <div className="card shadow-sm">
                  <div className="card-body">
                    <p className="text-muted">Tasks will appear here</p>
                  </div>
                </div>
              </div>
            </Tab>

          </Tabs>
        </div>
      </div>

      {/* View Quote Detail Modal */}
      <Modal show={showQuoteModal} onHide={() => setShowQuoteModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1.5rem', fontWeight: '600' }}>View Quote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingQuote ? (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div style={{ padding: '20px' }}>
              {console.log('💰 Modal rendering with quoteData:', quoteData)}
              {console.log('💳 Partner Rate Card:', partnerRateCard)}

              {/* Show partner rate card info if available */}
              {partnerRateCard && partnerRateCard.transactions && partnerRateCard.transactions.length > 0 && (
                <div style={{
                  backgroundColor: '#fff3cd',
                  border: '1px solid #ffc107',
                  borderRadius: '6px',
                  padding: '12px 16px',
                  marginBottom: '20px',
                  fontSize: '0.9rem',
                  color: '#856404'
                }}>
                  <strong>📋 Partner Rate Card Applied:</strong> Fees shown below are from partner's rate card
                </div>
              )}

              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '1.1rem' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                    <th style={{ padding: '16px 12px', textAlign: 'left', fontWeight: '600', color: '#495057', fontSize: '1rem' }}>
                      Will ({quoteData?.service_type || 'Single'})
                    </th>
                    <th style={{ padding: '16px 12px', textAlign: 'right', fontWeight: '600', color: '#495057', fontSize: '1rem' }}>
                      Net
                    </th>
                    <th style={{ padding: '16px 12px', textAlign: 'right', fontWeight: '600', color: '#495057', fontSize: '1rem' }}>
                      VAT
                    </th>
                    <th style={{ padding: '16px 12px', textAlign: 'right', fontWeight: '600', color: '#495057', fontSize: '1rem' }}>
                      Gross
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* 🎯 NEW: Display all fees from final_leads_calculations */}
                  {quoteData?.fees && Object.keys(quoteData.fees).length > 0 ? (
                    // New structure from getFormattedLeadCalculation API
                    <>
                      {Object.entries(quoteData.fees).map(([key, fee]) => (
                        <tr key={key} style={{ borderBottom: '1px solid #e9ecef' }}>
                          <td style={{ padding: '16px 12px', color: '#212529', fontWeight: '500' }}>
                            {fee.label || key}
                            {/* ❌ Branch name NOT shown for Will products */}
                          </td>
                          <td style={{ padding: '16px 12px', textAlign: 'right', color: '#212529', fontSize: '1.05rem' }}>
                            £{(fee.amount || 0).toFixed(2)}
                          </td>
                          <td style={{ padding: '16px 12px', textAlign: 'right', color: '#212529', fontSize: '1.05rem' }}>
                            £{(fee.vat || 0).toFixed(2)}
                          </td>
                          <td style={{ padding: '16px 12px', textAlign: 'right', fontWeight: '600', color: '#212529', fontSize: '1.1rem' }}>
                            £{(fee.gross || 0).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                      {/* Totals row */}
                      {quoteData.totals && (
                        <tr style={{ borderTop: '2px solid #dee2e6', backgroundColor: '#f8f9fa', fontWeight: 'bold' }}>
                          <td style={{ padding: '16px 12px', color: '#212529', fontSize: '1.1rem' }}>
                            Total
                          </td>
                          <td style={{ padding: '16px 12px', textAlign: 'right', color: '#212529', fontSize: '1.1rem' }}>
                            £{(quoteData.totals.total?.net || 0).toFixed(2)}
                          </td>
                          <td style={{ padding: '16px 12px', textAlign: 'right', color: '#212529', fontSize: '1.1rem' }}>
                            £{(quoteData.totals.total?.vat || 0).toFixed(2)}
                          </td>
                          <td style={{ padding: '16px 12px', textAlign: 'right', color: '#dc3545', fontSize: '1.2rem' }}>
                            £{(quoteData.totals.total?.gross || 0).toFixed(2)}
                          </td>
                        </tr>
                      )}
                    </>
                  ) : (
                    // Old structure fallback (backward compatibility)
                    <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                      <td style={{ padding: '16px 12px', color: '#212529', fontWeight: '500' }}>
                        Legal Fees
                        {partnerRateCard && (
                          <span style={{
                            marginLeft: '8px',
                            fontSize: '0.75rem',
                            color: '#6c757d',
                            fontWeight: '400'
                          }}>
                            (Partner Rate)
                          </span>
                        )}
                      </td>
                      <td style={{ padding: '16px 12px', textAlign: 'right', color: '#212529', fontSize: '1.05rem' }}>
                        £{(() => {
                          if (partnerRateCard && partnerRateCard.transactions && partnerRateCard.transactions.length > 0) {
                            const firstTransaction = partnerRateCard.transactions[0];
                            if (firstTransaction.propertyRangeFees && firstTransaction.propertyRangeFees.length > 0) {
                              return (firstTransaction.propertyRangeFees[0].legalFee || 0).toFixed(2);
                            }
                          }
                          return (quoteData?.mlmLegalCost || 0).toFixed(2);
                        })()}
                      </td>
                      <td style={{ padding: '16px 12px', textAlign: 'right', color: '#212529', fontSize: '1.05rem' }}>
                        £{(() => {
                          if (partnerRateCard && partnerRateCard.transactions && partnerRateCard.transactions.length > 0) {
                            const firstTransaction = partnerRateCard.transactions[0];
                            if (firstTransaction.propertyRangeFees && firstTransaction.propertyRangeFees.length > 0) {
                              const legalFee = firstTransaction.propertyRangeFees[0].legalFee || 0;
                              return (legalFee * 0.20).toFixed(2);
                            }
                          }
                          return (quoteData?.vat || 0).toFixed(2);
                        })()}
                      </td>
                      <td style={{ padding: '16px 12px', textAlign: 'right', fontWeight: '600', color: '#212529', fontSize: '1.1rem' }}>
                        £{(() => {
                          if (partnerRateCard && partnerRateCard.transactions && partnerRateCard.transactions.length > 0) {
                            const firstTransaction = partnerRateCard.transactions[0];
                            if (firstTransaction.propertyRangeFees && firstTransaction.propertyRangeFees.length > 0) {
                              const legalFee = firstTransaction.propertyRangeFees[0].legalFee || 0;
                              const vat = legalFee * 0.20;
                              return (legalFee + vat).toFixed(2);
                            }
                          }
                          return (quoteData?.totalCost || 0).toFixed(2);
                        })()}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outlined"
            size="small"
            onClick={generateWillQuotePDF}
            sx={{
              textTransform: 'none',
              borderColor: '#6c757d',
              color: '#6c757d',
              '&:hover': {
                borderColor: '#5a6268',
                backgroundColor: 'rgba(108, 117, 125, 0.04)'
              }
            }}
          >
            Download
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Revise Quote Modal */}
      <Modal show={showReviseModal} onHide={() => setShowReviseModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1.5rem', fontWeight: '600' }}>Revise Quote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ padding: '20px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '1.1rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                  <th style={{ padding: '16px 12px', textAlign: 'left', fontWeight: '600', color: '#495057', fontSize: '1rem' }}>
                    Will ({leadData?.service_type || 'Single'}) <span style={{ color: '#dc3545', marginLeft: '5px' }}>+</span>
                  </th>
                  <th style={{ padding: '16px 12px', textAlign: 'right', fontWeight: '600', color: '#495057', fontSize: '1rem' }}>
                    Net
                  </th>
                  <th style={{ padding: '16px 12px', textAlign: 'right', fontWeight: '600', color: '#495057', fontSize: '1rem' }}>
                    VAT
                  </th>
                  <th style={{ padding: '16px 12px', textAlign: 'right', fontWeight: '600', color: '#495057', fontSize: '1rem' }}>
                    Gross
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #e9ecef' }}>
                  <td style={{ padding: '16px 12px', color: '#212529', fontWeight: '500' }}>Legal Fees</td>
                  <td style={{ padding: '16px 12px', textAlign: 'right' }}>
                    <input
                      type="number"
                      step="0.01"
                      value={revisedNetValue}
                      onChange={(e) => setRevisedNetValue(parseFloat(e.target.value) || 0)}
                      style={{
                        width: '120px',
                        padding: '8px 12px',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        fontSize: '1rem',
                        textAlign: 'right'
                      }}
                    />
                  </td>
                  <td style={{ padding: '16px 12px', textAlign: 'right', color: '#212529', fontSize: '1.05rem' }}>
                    £{(revisedNetValue * 0.20).toFixed(2)}
                  </td>
                  <td style={{ padding: '16px 12px', textAlign: 'right', fontWeight: '600', color: '#212529', fontSize: '1.1rem' }}>
                    £{(revisedNetValue * 1.20).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn"
            style={{
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              padding: '8px 20px',
              fontSize: '0.9rem',
              fontWeight: '500',
              borderRadius: '4px'
            }}
            onClick={() => setShowReviseModal(false)}
          >
            Cancel
          </button>
          <button
            className="btn"
            style={{
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              padding: '8px 20px',
              fontSize: '0.9rem',
              fontWeight: '500',
              borderRadius: '4px'
            }}
            onClick={async () => {
              try {
                // Calculate VAT and Total
                const vat = revisedNetValue * 0.20;
                const totalCost = revisedNetValue + vat;

                // API call to update quote
                const response = await postRequest(
                  `private/update-will-quote/${id}`,
                  {
                    mlmLegalCost: revisedNetValue,
                    vat: vat,
                    totalCost: totalCost
                  },
                  authCtx.token
                );

                if (response?.status === 200) {
                  // Update Quote Summary data
                  setQuoteSummaryData({
                    ...quoteSummaryData,
                    mlmLegalCost: revisedNetValue,
                    vat: vat,
                    totalCost: totalCost
                  });

                  // Update quoteData if it's already loaded
                  if (quoteData) {
                    setQuoteData({
                      ...quoteData,
                      mlmLegalCost: revisedNetValue,
                      vat: vat,
                      totalCost: totalCost
                    });
                  }

                  // Refresh lead data to update quote history in Quotes tab
                  fetchLeadData();

                  // Show success message
                  Swal.fire({
                    icon: 'success',
                    title: 'Quote Revised!',
                    text: 'Quote has been updated successfully',
                    timer: 2000,
                    showConfirmButton: false
                  });

                  // Close modal
                  setShowReviseModal(false);
                } else {
                  Swal.fire('Error', 'Failed to revise quote', 'error');
                }
              } catch (error) {
                console.error('Error updating quote:', error);
              }
            }}
          >
            Revise Quote
          </button>
        </Modal.Footer>
      </Modal>

      {/* View Email Modal */}
      <Modal show={viewEmailModal} onHide={() => setViewEmailModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>View Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEmail ? (
            <div>
              <div
                dangerouslySetInnerHTML={{ __html: selectedEmail.content || 'No content available' }}
                style={{
                  maxHeight: '500px',
                  overflowY: 'auto',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}
              />
            </div>
          ) : (
            <div className="text-center py-3">
              <p className="text-muted">No email selected</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={() => setViewEmailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
